exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "token{width:100%;height:100%}.footer-token{font-size:12px}.corDisable{background-color:#f7eb98;border:1px solid #ddd;color:#a9a4a4}.linhaBottom{border-bottom:1px solid #ccc}.linhaTop{border-top:1px solid #ccc}.texto-passo{color:#a9a4a4;text-transform:uppercase;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/components/views/tokenEmail/tokenEmail.style.scss
// module id = 775
// module chunks = 0